import React from 'react';

interface LogoProps {
  className?: string;
}

/**
 * Logo Component
 * Optimized for hydration: Uses dangerouslySetInnerHTML for internal SVG styles 
 * to ensure the server-rendered HTML and client-rendered styles match exactly.
 */
export function Logo({ className }: LogoProps) {
  const styles = `
    .logo-title {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      font-size: 81px;
      font-weight: 500;
      fill: currentColor;
      letter-spacing: -1px;
    }
    .logo-line {
      stroke: #de2618;
    }
    @media (min-width: 768px) {
      .logo-title {
        font-size: 60px;
      }
    }
  `.trim();

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 700 120" 
      className={className}
      fill="currentColor"
    >
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <text x="0" y="80" className="logo-title">News Afrika</text>
      <line 
        x1="0" 
        y1="95" 
        x2="230" 
        y2="95" 
        className="logo-line"
        strokeWidth="6" 
      />
    </svg>
  );
}
